const hostMedia = 'eventsgo/media/'
// 用车申请日志查询
export const GET_VEH_LOG = hostMedia + 'services/eventsgo/public/changeLogService/findLogDetails'
